import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Grid, TextField } from '@material-ui/core';
import { regexConstants } from '../../../constants/regEx';
import { globalGetService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import ServerErrorModal from './ServerErrorModal';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import moment from 'moment';

class VerifyAmountModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verifyAmount: {},
            error: {},
            pageLoader: false,
            amountErrors: {},
            prsv_amount_paid: {},
            serverError: { modal: false },
            llp_amount_paid: ""
        };
    }
    getEngineLLPsApi = (id) => {
        globalGetService(`maintenance/shopvisit/${id}/llps/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    const total_llp_amount_paid = response?.data?.data?.length > 0 && response.data.data.reduce((total, item) => total + item.claim_amount, 0);
                    this.setState({
                        llp_amount_paid: total_llp_amount_paid ? total_llp_amount_paid : 0
                    })
                }
            })
    }

    componentDidMount() {
        this.getEngineLLPsApi(this.props?.event?.id)
    }

    onFieldChange = (e, keyParam, data, type) => {
        if (type === 'module') {
            this.setState(prevState => ({
                verifyAmount: {
                    ...prevState.verifyAmount,
                    prsv_amount_paid: {
                        ...prevState.verifyAmount.prsv_amount_paid,
                        [keyParam]: data
                    }
                }
            }));
        }else if(keyParam === 'payout_date'){
            this.setState(prevState => ({
                verifyAmount: {
                    ...prevState.verifyAmount,
                    [keyParam]: data
                }
            }));
        } else {
            this.setState(prevState => ({
                verifyAmount: {
                    ...prevState.verifyAmount,
                    [keyParam]: e.target.value
                }
            }));
        }
    };

    updateErrorField = (key, message) => {
        this.setState(prevState => ({
            ...prevState,
            error: {
                ...prevState.error,
                [key]: message
            },
            amountErrors: {
                ...prevState.amountErrors,
                [key]: message
            }
        }))
    }

    approveAmountFn = () => {
        const { item, event, verifyAmountData, enqueueSnackbar, toggleModalFn, getResponseBack } = this.props;
        const { verifyAmount, llp_amount_paid } = this.state;

        const errors = {};
        const showClaimError = (toastAmount) => {
            this.props.enqueueSnackbar(`Verify Amount exceeds Claim Amount limit (Max: US$${toastAmount}).`, {
                variant: 'error',
                anchorOrigin: { vertical: 'top', horizontal: 'right' }
            });
        };

        verifyAmountData?.moduleList?.forEach(item2 => {
            const paidAmount = verifyAmount?.prsv_amount_paid?.[item2.label];
            if (verifyAmount?.prsv_amount_paid && paidAmount === '') {
                errors[item2.label] = `${item2.label} Claim Amount is required`;
            }
        });
        if (event?.asset_type == 2 && verifyAmount?.amount_paid === "" && !event?.prsv && !event?.llp_replacement) {
            errors["amount_paid"] = `Claim Amount is required`;
        } else if (event?.asset_type == 2 && verifyAmount?.amount_paid === "" && event?.prsv && !verifyAmountData?.moduleList?.length) {
            errors["amount_paid"] = `PRSV Claim Amount is required`;
        }
        else if (event?.asset_type !== 2 && verifyAmount?.amount_paid === "") {
            errors["amount_paid"] = `Claim Amount is required`;
        }
        if (!verifyAmount?.payout_date) {
            errors["payout_date"] = "Please enter Payout Date";
        }
        const numericAmountPaid = verifyAmountData?.moduleList?.length > 0 && verifyAmount?.prsv_amount_paid && Object.keys(verifyAmount?.prsv_amount_paid)?.length > 0 && Object.fromEntries(
            Object.entries(verifyAmount?.prsv_amount_paid)?.map(([key, value]) => [key, Number(value)])
        );
        const claimModuleAmountPaid = verifyAmountData?.moduleList?.length > 0 && item?.prsv_claim_amount && Object.keys(item?.prsv_claim_amount)?.length > 0 && Object.fromEntries(
            Object.entries(item?.prsv_claim_amount)?.map(([key, value]) => [key, Number(value)])
        );
        const totalModuleCost = numericAmountPaid && (Object.values(numericAmountPaid).reduce((sum, value) => sum + value, 0) || 0)
        const totalClaimModuleCost = claimModuleAmountPaid && (Object.values(claimModuleAmountPaid).reduce((sum, value) => sum + value, 0) || 0)
        if (event?.prsv && item?.claim_amount && verifyAmount?.amount_paid && Number(verifyAmount?.amount_paid) > item?.claim_amount) {
            showClaimError(item?.claim_amount);
            return;
        }
        else if (!verifyAmountData?.moduleList?.length && llp_amount_paid && item.llp_claim_amount && event?.llp_replacement && (Number(llp_amount_paid)) > item.llp_claim_amount) {
            showClaimError(item.llp_claim_amount);
            return;
        } else if (event?.asset_type !== 2 && item?.claim_amount && Number(verifyAmount?.amount_paid) > item?.claim_amount) {
            showClaimError(item?.claim_amount);
            return;
        } else if (event?.asset_type === 2 && item?.claim_amount && !event?.prsv && !event?.llp_replacement && Number(verifyAmount?.amount_paid) > item?.claim_amount) {
            showClaimError(item?.claim_amount);
            return;
        } else if (verifyAmountData?.moduleList?.length > 0 && Number(llp_amount_paid) && (totalModuleCost + Number(llp_amount_paid)) > (totalClaimModuleCost + item?.llp_claim_amount)) {
            showClaimError(totalClaimModuleCost + item?.llp_claim_amount);
            return;
        }
        else if (verifyAmountData?.moduleList?.length > 0 && totalModuleCost > totalClaimModuleCost) {
            showClaimError(totalClaimModuleCost);
            return;
        } else if (event?.llp_replacement && llp_amount_paid == 0 && !verifyAmountData?.moduleList?.length) {
            this.setState(prevState => ({
                serverError: {
                    ...prevState.serverError,
                    modal: true,
                    data: { errors: [{ key: "LLP", message: "To update the LLP amount, please visit the LLP page using the link below. It will redirect you directly to the relevant section" }] }
                }
            }));
            return;
        }

        if (Object.keys(errors).every((k) => { return errors[k] === '' })) {
            let payload = {}
            if (verifyAmountData?.moduleList?.length > 0) {
                payload.prsv_amount_paid = { ...item?.prsv_claim_amount, ...numericAmountPaid };
            }
            if (verifyAmount?.amount_paid || item?.claim_amount) {
                payload.amount_paid = verifyAmount.amount_paid ? Number(verifyAmount.amount_paid) : item?.claim_amount
            }
            const isLLPReplacementCondition =
                (event?.asset_type === 2 && event?.llp_replacement) ||
                (item?.asset_type === "engine" && item?.shop_visit_events?.llp_replacement);

            if (isLLPReplacementCondition && llp_amount_paid) {
                payload.llp_amount_paid = llp_amount_paid ? Number(llp_amount_paid) : item?.llp_claim_amount
            }
            if (verifyAmount?.payout_date) {
                payload.payout_date = verifyAmount.payout_date;
            }
            this.setState({ pageLoader: true });
            globalPutService(`maintenance/${item?.asset_type}/asset/${event?.asset_slug}/claims/${item?.id}/claim-amount-approval/`, payload)
                .then(response => {
                    this.setState({ pageLoader: false });
                    if (checkApiStatus(response)) {
                        toggleModalFn()
                        this.setState({ verifyAmount: {} });
                        // changeClaimStatus({ payout_status:  5 })
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    } else {
                        if (response?.data?.statusCode == 406 && response?.data?.status == "FAIL" && response?.data?.error?.errors?.length > 0) {
                            this.setState(prevState => ({
                                serverError: {
                                    ...prevState.serverError,
                                    modal: true,
                                    data: response?.data?.error
                                }
                            }));
                        } else enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    }
                });
        } else {
            this.setState({ amountErrors: errors });
        }
    };

    render() {
        const { verifyAmountData, toggleModalFn, item, event } = this.props;
        const { pageLoader, verifyAmount, amountErrors, serverError, llp_amount_paid } = this.state;
        return (
            <> <Dialog
                maxWidth={'md'}
                minHeight={100}
                open={verifyAmountData?.modal}
                onClose={toggleModalFn}
                aria-labelledby="scroll-dialog-title"
                className='verify-amount-modal add-edit-work-order-modal'
            >
                <DialogTitle id="scroll-dialog-title">{`Please Verify Claimable Amount`} </DialogTitle>
                <DialogContent dividers={true} tyle={{ maxHeight: "402px", height: "500px", overflowY: "none" }}>
                    {/* {pageLoader ? <PageLoader /> : */}
                    <Grid container spacing={2}>
                        {(event?.asset_type !== 2 || item?.asset_type !== "engine") || (!verifyAmountData?.moduleList?.length && !event?.prsv && !event?.llp_replacement) ?
                            <Grid item xs={12}>
                                <TextField
                                    defaultValue={String(item?.claim_amount)}
                                    required
                                    label="Claim Amount"
                                    fullWidth
                                    margin="normal"
                                    value={verifyAmount?.amount_paid}
                                    onChange={e => {
                                        if (regexConstants.decimalnodotstart.test(e.target.value) && e.target.value !== ".") {
                                            this.onFieldChange(e, 'amount_paid', e.target.value);
                                        } else {
                                            e.preventDefault();
                                        }
                                    }}
                                    onFocus={() => this.updateErrorField('amount_paid', '')}
                                    error={!!amountErrors.amount_paid}
                                    helperText={amountErrors.amount_paid || ''}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    inputProps={{ maxLength: 10 }}
                                />
                            </Grid> : null}

                        {((event?.asset_type === 2 && event?.prsv) || (item?.asset_type === "engine" && item?.shop_visit_events?.prsv)) && !verifyAmountData?.moduleList?.length ?
                            <Grid item xs={((event?.asset_type === 2 && event?.llp_replacement) || (item?.asset_type === "engine" && item?.shop_visit_events?.llp_replacement)) ? 6 : 12}>
                                <TextField
                                    defaultValue={String(item?.claim_amount)}
                                    required
                                    label="PRSV Claim Amount"
                                    fullWidth
                                    margin="normal"
                                    value={verifyAmount?.amount_paid}
                                    onChange={e => {
                                        if (regexConstants.decimalnodotstart.test(e.target.value) && e.target.value !== ".") {
                                            this.onFieldChange(e, 'amount_paid', e.target.value);
                                        } else {
                                            e.preventDefault();
                                        }
                                    }}
                                    onFocus={() => this.updateErrorField('amount_paid', '')}
                                    error={!!amountErrors.amount_paid}
                                    helperText={amountErrors.amount_paid || ''}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    inputProps={{ maxLength: 10 }}
                                />
                            </Grid> : null}

                        {((event?.asset_type === 2 && event?.llp_replacement) || (item?.asset_type === "engine" && item?.shop_visit_events?.llp_replacement)) &&
                            <Grid item xs={((event?.asset_type === 2 && event?.prsv) || (item?.asset_type === "engine" && item?.shop_visit_events?.prsv)) ? 6 : 12}>
                                <TextField
                                    disabled
                                    label={"LLP Amount"}
                                    fullWidth
                                    margin="normal"
                                    value={llp_amount_paid}
                                    InputLabelProps={{ shrink: true }}
                                    className='disable'
                                    variant='outlined'
                                    inputProps={{ maxLength: 10 }}
                                />
                                {!verifyAmountData?.moduleList?.length ?  <p style={{ fontSize: '11px', background: '#FFF8B9', width: 'fit-content', width: "280px" }}>Note: To update the LLP amount, please visit the LLP page using the link below. It will redirect you directly to the relevant section. <span
                                    onClick={() => this.props.handleTabChange("", 1)}
                                    style={{
                                        color: '#007bff',
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        display: 'inline-block',
                                        marginLeft: "4px",
                                        fontSize: "11px"
                                    }}
                                >
                                    Manage LLP Amount
                                </span></p> :null}
                               
                            </Grid>}

                        {((event?.asset_type === 2 && event?.prsv) || (item?.asset_type === "engine" && item?.shop_visit_events?.prsv)) &&
                            verifyAmountData?.moduleList?.length > 0 && verifyAmountData?.moduleList?.map((module, index) => (
                                <Grid item xs={verifyAmountData?.moduleList?.length === 1 ? 12 : 6} key={index}>
                                    <TextField
                                        defaultValue={(item?.prsv_claim_amount && String(item?.prsv_claim_amount[module.label]))}
                                        required
                                        label={`${module?.label} Amount`}
                                        fullWidth
                                        margin="normal"
                                        value={(verifyAmount?.prsv_amount_paid && verifyAmount?.prsv_amount_paid[module.label])}
                                        onChange={e => {
                                            if (regexConstants.decimalnodotstart.test(e.target.value) && e.target.value !== ".") {
                                                this.onFieldChange(e, module.label, e.target.value, "module");
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                        onFocus={() => this.updateErrorField(module.label, '')}
                                        error={!!amountErrors[module.label]}
                                        helperText={amountErrors[module.label] || ''}
                                        InputLabelProps={{ shrink: true }}
                                        variant='outlined'
                                        inputProps={{ maxLength: 10 }}
                                    />
                                </Grid>
                            ))}
                        <Grid item xs={12} md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    required
                                    margin="normal"
                                    id="payout_date"
                                    label="Payout Date"
                                    format={fieldDateFormat}
                                    fullWidth
                                    variant='outlined'
                                    inputVariant='outlined'
                                    disableFuture
                                    InputLabelProps={{ shrink: true }}
                                    clearable={true}
                                    minDate={moment().subtract(25, 'years')}
                                    value={verifyAmount?.payout_date ? moment(verifyAmount.payout_date) : null}
                                    error={amountErrors.payout_date ? true : false}
                                    helperText={amountErrors.payout_date ? amountErrors.payout_date : ''}
                                    onFocus={() => this.updateErrorField('payout_date', '')}
                                    onChange={(date) => { if (date && moment(date).isValid()) { this.onFieldChange(null, 'payout_date', moment(date).format(backendDateFormat)); this.updateErrorField('payout_date', ''); } }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                  
                </DialogContent>
                <DialogActions>
                    <div style={{ float: 'right' }}>
                        <Button onClick={toggleModalFn} color="primary" className='mr-5' variant='outlined' size="small">Cancel</Button>
                        <Button
                            variant="contained"
                            onClick={this.approveAmountFn}
                            color="primary"
                            size="small"
                        >
                            {pageLoader ? <CircularProgress color="#ffffff" size={24} /> : 'Verify Amount'}
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
                {serverError?.modal ? <ServerErrorModal isLLP = {event?.llp_replacement} handleTabChange={this.props.handleTabChange} serverError={serverError} toggleModalFn={() => this.setState({ serverError: { modal: false, data: [] } })} /> : null}</>

        );
    }
}

export default withSnackbar(VerifyAmountModal);
